module.exports = __webpack_public_path__ + "static/emperor-5d10434951fe8f070f031444f24ef79d.jpg";